import isValidCep from '@brazilian-utils/is-valid-cep';

import { registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';

import { createAlphanumericFormatter } from '../generators';

export const POSTAL_CODE = 'postal-code';

const PostalCodeFormatter = createAlphanumericFormatter({
  name: POSTAL_CODE,
  mask: '00000-000',
  validate: isValidCep,
  invalidMessage: 'tws.formatter.postalCode.invalid',
});

export default registerFormatter(POSTAL_CODE, PostalCodeFormatter);
